import { useSelector } from 'react-redux';

// @ts-expect-error Untyped module
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { getUserId } from 'ContentEditorUI/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatePageModal = ({
  closeModal,
  contentTypeId,
  domainName
}) => {
  const userId = useSelector(getUserId);
  return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
    children: ({
      ActiveThemeCreatePageModal
    }) => /*#__PURE__*/_jsx(ActiveThemeCreatePageModal, {
      referrer: "ContentEditorUI",
      userId: userId,
      contentTypeCategoryId: contentTypeId,
      closeModal: closeModal,
      siteDomain: domainName
    })
  });
};
export default CreatePageModal;